import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Log from "../Services/Log";
import { triggerReload } from "../slices/reduxUtils";
import { BASE_URL } from "../constants/apiEndPoints";

if (window.location.host === "localhost:3000") {
  axios.defaults.baseURL =
    "https://5zq98tvohg.execute-api.ap-south-1.amazonaws.com/";
} else {
  axios.defaults.baseURL = `${window.location.origin}/`;
}
axios.defaults.headers.post["Content-Type"] = "application/json";
// axios.defaults.withCredentials = true;
const refreshToken = localStorage.getItem("refreshToken");

let isRefreshing = true;
const refreshAuthToken = async () => {
  if (isRefreshing) {
    try {
      isRefreshing = false;
      // console.log('refreshToken:', refreshToken);
      const response = await axios.post(`${BASE_URL}/refresh/token`, {
        refresh_token: refreshToken,
      });

      const newRefreshToken = response.response.refreshToken;
      const newAccessToken = response.response.accessToken;
      console.log("new AccessToken", newAccessToken);
      localStorage.setItem("accessToken", newAccessToken);
      localStorage.setItem("refreshToken", newRefreshToken);

      return newAccessToken;
    } catch (error) {
      console.log("error", error);
      if (error.response && error.response.status === 401) {
        // Clear the local storage and redirect to login
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userDetails");
        window.location.href = "/login"; // Assuming "/login" is your login route
      }
      console.error("Failed to refresh token:", error);
      throw error;
    }
  }
};

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `${token}`;
    }
    return config;
  },
  function (error) {
    console.log("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

const logOut = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userDetails");
  window.location.href = "/login";
};
// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  async function (error) {
    let message;
    const originalRequest = error.config;

    if (error.response) {
      switch (error.response.status) {
        case 500:
          message = "Internal Server Error. Please try again later.";
          break;
        case 401:
          if (!originalRequest._retry) {
            console.log("originalRequest", originalRequest.url);

            // originalRequest._retry = true;
            try {
              const newToken = await refreshAuthToken();
              // originalRequest.headers["Authorization"] = newToken;
              // const retryResponse = await axios(originalRequest);
              if (newToken) {
                triggerReload();
              }
              // return retryResponse;
            } catch (refreshError) {
              // console.log('refreshError',refreshError);
              // message = "Session expired. Please log in again."
              // return Promise.reject(refreshError)
            }
            if (originalRequest.url == `${BASE_URL}/refresh/token`) {
              window.location.href = "/login";
            }
          } else {
            message = "Invalid credentials";
          }
          break;
        case 404:
          message = "Sorry! The data you are looking for could not be found.";
          break;
        case 400:
          message =
            error?.response?.data?.message ||
            error.message ||
            "An unexpected error occurred.";
          break;
        case 413:
          message =
            "The file size is too large to process. Please try uploading a smaller file.";
          break;
        case 502:
          message =
            "Bad Gateway. The server is currently unavailable. Please try again later.";
          break;
        default:
          message = error.message || "An unexpected error occurred.";
        // message = data && data?.message || error.message || "An unexpected error occurred.";
      }
    } else if (error.request) {
      if (!error)
        if (!originalRequest._retry) {
          // Retry logic for network issues or server not responding
          originalRequest._retry = true;
          try {
            return axios(originalRequest);
          } catch (retryError) {
            message = "Request failed. Retrying...";
          }
          triggerReload();
        } else {
          message = "An unexpected error occurred";
        }
    } else {
      message = error.message || "An unexpected error occurred";
    }

    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
    });

    return Promise.reject(message);
  }
);

const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = token;
};

class APIClient {
  get = (url, params) => {
    let response;
    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(url);
    }

    return response;
  };

  create = (url, data) => {
    return axios.post(url, data);
  };

  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };

  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("userDetails");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

const api = new APIClient();

export { APIClient, setAuthorization, getLoggedinUser, api };
